import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import RoutesPath from "../../Utils/RoutesPath";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { PngImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import { AuthContext } from "../../Context/authContext";
import { Modal } from "react-bootstrap";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { handleApiErrors } from "../../Utils/Utils";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment/moment";

const BharatSat = () => {
  const { ExamTime } = useParams();
  const { user } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [examId, setExamId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  // const [currentTime, setCurrentTime] = useState(null);
  const navigate = useNavigate();

  const formatTime = (isoTime) => {
    if (!isoTime) return "";

    // Use Moment.js to parse the ISO time string and format it in 12-hour format with AM/PM
    return moment(isoTime).format("hh:mm A");
  };

  const examDateTime = new Date(user.examStartTime).getTime();

  const calculateTimeLeft = () => {
    const now = new Date().getTime();
    const difference = examDateTime - now;
    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [user.examStartTime]);


  // // Handle activation attempt
  const handleActivationClick = (e) => {
    navigate(`${RoutesPath.bharatSatTest}/${user.bharatSatExamId}`);
  };



  const instructions = [
    "Camera Visibility: Ensure your camera is on and you are clearly visible from head to chest throughout the examination.",
    "Fair Play: Maintain academic integrity. Do not engage in any form of cheating or malpractice.",
    "No Communication: Refrain from communicating with anyone during the examination.",
    "No External Assistance: Do not seek help from any external source, including textbooks, notes, or online resources.",
    "Time Management: The examination duration is 90 minutes. Allocate time wisely to answer all questions.",
    "Question Format: The examination consists of 100 Multiple Choice Questions (MCQs).",
    "Marking Scheme: Each correct answer carries 2 marks.",
    "Submission Deadline: The examination will be automatically submitted after 90 minutes. Ensure you submit your answers before the deadline.",
    "Result Implications: Any violation of the examination rules may lead to the cancellation of your result.",
    "The merit list will be prepared based on the marks obtained by the student and the time they took to complete the test.",
    "Each incorrect answer will result in a deduction of 0.5 marks from your total score. Please be mindful of this when answering the questions.",
  ];
  const handleClose = () => {
    setShow(false);
  };

  const removeTimeFromDate = (dateString) => {
    if (!dateString) return "";
    const dateObject = new Date(dateString);
    // Ensure the date is parsed as UTC
    const utcYear = dateObject.getUTCFullYear();
    const utcMonth = dateObject.toLocaleString("default", {
      month: "long",
      timeZone: "UTC",
    });
    const utcDay = dateObject.getUTCDate();
    return `${utcDay} ${utcMonth} , ${utcYear}`;
  };

  return (
    <div className="d-flex">
      <Sidebar /> {/* Sidebar component */}
      <div className="mainLayout-content">
        <StudentNavbar /> {/* Navbar component */}
        <div className="main_content contentSection scroll_bar">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black  fw-700 Header-student-text mb-0">
              Bharat SAT
            </h1>
            {/* <Link to={RoutesPath.bharatsat}>
                            <div className="d-flex" style={{ paddingRight: "10px" }}>
                                <h4 className="Caption fw-600  mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
                            </div>
                        </Link> */}
          </div>

          {user.examTimeOver == false && user.hallTicketNumber == null ? (
            <h1 className=" small-medium-text fw-600">
              Details about the upcoming Bharat SAT exam will be shared here
              soon. Please check back regularly for updates on exam dates,
              syllabus, and other important information.
            </h1>
          ) : null}




          <>
            {user?.bharatSatExamDate === null ? (
              <>
                {(user.examTimeOver === true && user.examAttempted === false) ? (
                  <div
                    className="no-records-container text-center"
                    style={{ height: "calc(80vh - 5.2rem)" }}
                  >
                    <div
                      className="d-flex flex-column align-items-center justify-content-center"
                      style={{ height: "60vh" }}
                    >
                      {
                        user.examTimeOver === true ? (
                          <p
                            className="Small-Heading text-danger fw-700 mb-0"
                            style={{ marginTop: "54px" }}
                          >
                            Time Is Over!
                          </p>
                        ) : null
                        // <p className='Small-Heading fw-700 mb-0' style={{ marginTop: '54px' }}>You’re Early</p>
                      }
                      <div
                        className="no-record-image w-auto"
                        style={{
                          backgroundColor: "transparent",
                          marginTop: "0px",
                        }}
                      >
                        <Image
                          src={PngImages.earlyexamimage}
                          className="img-fluid"
                        />
                      </div>
                      {/*                   
                  {user.examTimeOver === true ? null :
                    <p className="no-records-text sub-large-text-one fw-700 my-4">
                      You cannot access the exam before the scheduled time.
                    </p>
                  }
                  */}
                    </div>
                  </div>
                ) :
                  <>
                    {user.examAttempted === true && user.examTimeOver === true ? 
                      <>
                        <div
                          className="no-records-container bg-white text-center"
                          style={{ height: "calc(80vh - 5.2rem)" }}
                        >
                          <div
                            className="d-flex flex-column align-items-center justify-content-center"
                            style={{ height: "60vh" }}
                          >
                            <div
                              className="no-record-image w-auto"
                              style={{
                                backgroundColor: "transparent",
                                marginTop: "0px",
                              }}
                            >
                              <Image
                                src={PngImages.complete_Exam}
                                className="img-fluid"
                              />
                            </div>
                            <p
                              className="Small-Heading fw-700 mb-0"
                              style={{ marginTop: "45px", color: "#368C36" }}
                            >
                              Thank you for completing your exam!{" "}
                            </p>
                            <p className="sub-large-text-one  fw-500 mb-0">
                              {" "}
                              The results will be displayed shortly. Please stay
                              tuned.
                            </p>
                          </div>
                        </div></>
                        :null
                    }

                  </>
                }
              </>
            ) : (
              <>
                {user.examAttempted === true ? (
                  <div
                    className="no-records-container bg-white text-center"
                    style={{ height: "calc(80vh - 5.2rem)" }}
                  >
                    <div
                      className="d-flex flex-column align-items-center justify-content-center"
                      style={{ height: "60vh" }}
                    >
                      <div
                        className="no-record-image w-auto"
                        style={{
                          backgroundColor: "transparent",
                          marginTop: "0px",
                        }}
                      >
                        <Image
                          src={PngImages.complete_Exam}
                          className="img-fluid"
                        />
                      </div>
                      <p
                        className="Small-Heading fw-700 mb-0"
                        style={{ marginTop: "45px", color: "#368C36" }}
                      >
                        Thank you for completing your exam!{" "}
                      </p>
                      <p className="sub-large-text-one  fw-500 mb-0">
                        {" "}
                        The results will be displayed shortly. Please stay
                        tuned.
                      </p>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="row justify-content-center bharatsatticket-content">
                      <div className="col-md-7 p-0 bg-color-light border-section-one responsive-width-section">
                        <div className="d-flex">
                          <div className="reponsive-img-hide-two">
                            <Image
                              src={PngImages.ticketdesign}
                              className="border-section-one h-100"
                            />
                          </div>
                          <div>
                            <div className="bharat-ticket-padding">
                              <div className="d-flex flex-wrap gap-2">
                                <div>
                                  <h1 className="large-bharat-ticket-text fw-700 blue">
                                    Name :
                                  </h1>
                                </div>
                                <div>
                                  <h1 className="large-bharat-ticket-text fw-700 blue">
                                    {user?.firstName +
                                      " " +
                                      user?.middleName +
                                      " " +
                                      user?.lastName}
                                  </h1>
                                </div>
                              </div>
                              <div className="d-flex flex-wrap mt-3 gap-2 align-items-center">
                                <div
                                  className="d-flex gap-2"
                                  style={{ borderRight: "1px dashed #CCCCCC" }}
                                >
                                  <div>
                                    <h1 className="sub-large-text-one fw-400 ">
                                      Class :
                                    </h1>
                                  </div>
                                  <div>
                                    <h1 className="sub-large-text-one fw-600 px-2 ps-0">
                                      {user?.class_name}
                                    </h1>
                                  </div>
                                </div>
                                <div className="d-flex flex-wrap gap-2">
                                  <div>
                                    <h1 className="sub-large-text-one fw-400 ">
                                      Medium :
                                    </h1>
                                  </div>
                                  <div>
                                    <h1 className="sub-large-text-one fw-600">
                                      {user?.medium}
                                    </h1>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex flex-wrap gap-2 mt-3">
                                <div>
                                  <h1 className="sub-large-text-one fw-400 ">
                                    E-Hall Ticket No. :
                                  </h1>
                                </div>
                                <div>
                                  <h1 className="sub-large-text-one fw-600 blue">
                                    {user?.hallTicketNumber}
                                  </h1>
                                </div>
                              </div>
                              <div className="d-flex flex-wrap gap-2 mt-3">
                                <div>
                                  <h1 className="sub-large-text-one fw-400 ">
                                    Exam Date :
                                  </h1>
                                </div>
                                <div>
                                  <h1 className="sub-large-text-one fw-600 ">
                                    {removeTimeFromDate(user?.bharatSatExamDate)}
                                  </h1>
                                </div>
                              </div>
                              <div className="d-flex flex-wrap gap-2 mt-3">
                                <div>
                                  <h1 className="sub-large-text-one fw-400 ">
                                    Exam Time :
                                  </h1>
                                </div>
                                <div>
                                  <h1 className="sub-large-text-one fw-600">
                                    {formatTime(user?.examStartTime)} -{" "}
                                    {formatTime(user?.examEndTime)}
                                  </h1>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex flex-wrap gap-4 px-4 pb-4 align-items-center">
                              {/* {
                          user.examAttempted === true ? (
                            <div className='sub-large-text-one fw-700 blue' style={{ padding: '0px 25px', color: "#368C36" }}>
                              Your Exam is Already Submitted.
                            </div>
                          ) : */}
                              <div>
                                <SubmitButtonTwo
                                  title={"Activate your Bharat SAT exam"}
                                  className="bharatsatexamticketbtn"
                                  // disabled={!isButtonEnabled}
                                  onclick={handleActivationClick}
                                />
                              </div>
                              {/* } */}
                              {/* {user.examAttempted === true ? null : ( */}
                              <div>
                                <h2
                                  className="sub-large-text-one fw-700 orangeAccentColor border-bottom-orange cursor-pointer"
                                  onClick={() => {
                                    setShow(true);
                                  }}
                                >
                                  Guidelines For Exam Day
                                </h2>
                              </div>
                              {/* )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 bg-color-dark border-section reponsive-img-hide-two">
                        <div className="d-flex justify-content-center align-items-center h-100">
                          <Image
                            src={PngImages.learnachievebharatsatlogo}
                            className="img-fluid object-fit-contain"
                          />
                        </div>
                      </div>

                      <Modal
                        show={show}
                        onHide={handleClose}
                        size="xl"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        contentClassName="rounded-5"
                      >
                        <div className="border m-5">
                          <div
                            className="d-flex justify-content-between mb-3 align-items-center px-3 py-2"
                            id="contained-modal-title-vcenter"
                            style={{ backgroundColor: "#EFF5FF" }}
                          >
                            <h2 className="Heading headingColor text-center fw-600">
                              Instructions:
                            </h2>
                            <div className="medium-text fw-500 text-danger fst-italic">
                              Please read the instructions carefully before
                              starting the test.
                            </div>
                          </div>

                          <Modal.Body>
                            <div className="container-fluid ps-4">
                              {instructions.map((instruction, index) => (
                                <div key={index} className="mb-4">
                                  <div className="mb-2 medium-text fw-600 d-flex">
                                    <span className="fst-italic">
                                      {index + 1}. &nbsp;
                                    </span>
                                    <em className="medium-text fw-400">
                                      {instruction}
                                    </em>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Modal.Body>
                          {/* <Modal.Footer className="text-center border-0 d-flex justify-content-center">
              <div>

                <SubmitButtonTwo
                  title={"Start Test"}
                  className="start-test-btn"
                  onclick={handleStartTest}
                />

              </div>
            </Modal.Footer> */}
                        </div>
                      </Modal>
                    </div>
                    <div className="">
                      <em className="medium-text fw-600 d-flex justify-content-center align-items-center mb-4">Time Left for exam</em>
                      <div className="d-flex gap-3 justify-content-center align-items-center">
                        <div className=" ">
                          <h3 className="fw-700 blue pb-2 d-flex justify-content-center align-items-center">{timeLeft.days}</h3>
                          <span className="text-white fw-400 py-2 rounded-pill px-4" style={{ background: "#14489F" }}>Days</span>
                        </div>
                        <span className="medium-text text-muted fw-400"> :</span>
                        <div className=" ">
                          <h3 className="fw-700 blue pb-2 d-flex justify-content-center align-items-center">{timeLeft.hours}</h3>
                          <span className="text-white fw-400 py-2 rounded-pill px-4" style={{ background: "#14489F" }} >Hours</span>
                        </div>
                        <span className="medium-text text-muted fw-400"> :</span>
                        <div className=" ">
                          <h3 className="fw-700 blue pb-2 d-flex justify-content-center align-items-center">{timeLeft.minutes}</h3>
                          <span className="text-white fw-400 py-2 rounded-pill px-4" style={{ background: "#14489F" }} >Mins</span>
                        </div>
                        <span className="medium-text text-muted fw-400"> :</span>
                        <div className=" ">
                          <h3 className="fw-700 blue pb-2 d-flex justify-content-center align-items-center">{timeLeft.seconds}</h3>
                          <span className="text-white fw-400 py-2 rounded-pill px-4" style={{ background: "#14489F" }}>Secs</span>
                        </div>
                      </div>
                      {/* <h3 className="">
                        {timeLeft.days}d : {timeLeft.hours}h : {timeLeft.minutes}m : {timeLeft.seconds}s
                      </h3>
                      <h3 className="">
                        d : h : m : s
                      </h3> */}
                    </div>
                  </>
                )}
              </>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default BharatSat;
